var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerizonDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8542 7.54167V2.6875H17.3125V7.54167H10.8542ZM2.6875 10.75V2.6875H9.14583V10.75H2.6875ZM10.8542 17.3125V9.25H17.3125V17.3125H10.8542ZM2.6875 17.3125V12.4583H9.14583V17.3125H2.6875ZM4.25 9.1875H7.58333V4.25H4.25V9.1875ZM12.4167 15.75H15.75V10.8125H12.4167V15.75ZM12.4167 5.97917H15.75V4.25H12.4167V5.97917ZM4.25 15.75H7.58333V14.0208H4.25V15.75Z",
    fill: "#40444D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerizonDashboardIcon);
export default __webpack_public_path__ + "static/media/verizonDashboardIcon.f1b7b9ebca5f7a2a709de169925dfe16.svg";
export { ForwardRef as ReactComponent };